module.exports = __webpack_public_path__ + "img/logo_v2.327e4685.svg";